import React, { useEffect } from "react";
import fbIcon from "entities/accounts/components/plaform-icon/icons/fb.image.svg";
import igIcon from "entities/accounts/components/plaform-icon/icons/ig.image.svg";
import liIcon from "entities/accounts/components/plaform-icon/icons/ln.image.svg";
import gmbIcon from "entities/accounts/components/plaform-icon/icons/gmb.image.svg";
import tiktokIcon from "entities/accounts/components/plaform-icon/icons/tt.image.svg";
import UnknownUserAvatarSvg from "./unknown-user-avatar.svg";
import { AccountPlatformType } from "shared/types/accounts";

interface Props {
  src: string | undefined | null;
  name: string;
  size?: number;
  platform?: AccountPlatformType;
  showInitial?: boolean;
  unknownUser?: boolean;
  onError?: () => void;
}

const iconMap: Partial<Record<AccountPlatformType, string>> = {
  IG: igIcon,
  FB: fbIcon,
  LI: liIcon,
  GMB: gmbIcon,
  TT: tiktokIcon,
};

export function ConversationAvatar({
  src,
  name = "",
  size = 34,
  platform,
  showInitial,
  onError: onErrorProp,
  unknownUser,
}: Props): JSX.Element {
  const [isError, setError] = React.useState(false);
  const onError = () => {
    onErrorProp?.();
    setError(true);
  };
  useEffect(() => {
    if (src) {
      setError(false);
    }
  }, [src]);
  const splitName = name?.split(" ");
  const initial = `${splitName?.[0]?.[0] ?? ""}${splitName?.[1]?.[0] ?? ""}`;

  if (showInitial) {
    return (
      <div className="relative">
        <div
          className="rounded-full bg-accent-blurple-soft flex items-center justify-center overflow-hidden"
          style={{ width: size, height: size }}
          data-testid="conversation-avatar"
        >
          <div className="text-accent-blurple font-semibold text-[13px]">
            {initial}
          </div>
        </div>
      </div>
    );
  }

  function renderAvatar() {
    if (unknownUser) {
      return (
        <UnknownUserAvatarSvg
          className="w-full h-full"
          data-testid="unknown-user-avatar"
        />
      );
    }

    return src && !isError ? (
      <img
        className="w-full h-full object-cover"
        src={src}
        onError={onError}
        data-testid="conversation-avatar"
      />
    ) : (
      <div className="text-accent-blurple font-semibold text-[13px]">
        {initial}
      </div>
    );
  }

  return (
    <div className="relative">
      <div
        className="rounded-full bg-accent-blurple-soft flex items-center justify-center overflow-hidden"
        style={{ width: size, height: size }}
      >
        {renderAvatar()}
      </div>
      {platform && iconMap[platform] && (
        <img
          className="w-[11px] h-[11px] absolute bottom-0 right-0"
          src={iconMap[platform]}
          alt={platform}
        />
      )}
    </div>
  );
}
